<template>
  <div class="triangles-separator">
    <div class="bg"></div>
    <img
      :src="require('@/assets/images/bg-back.png')"
      class="triangles bg-back bg-rellax"
      draggable="false"
      alt=""
      data-rellax-zindex="1"
      data-rellax-speed="2.5"
    />
    <img
      :src="require('@/assets/images/bg-middle.png')"
      class="triangles bg-middle bg-rellax"
      draggable="false"
      alt=""
      data-rellax-zindex="2"
      data-rellax-speed="1.5"
    />
    <img
      :src="require('@/assets/images/bg-front.png')"
      class="triangles bg-front"
      draggable="false"
      alt=""
    />
    <img
      :src="require('@/assets/images/bg-clouds.png')"
      class="triangles bg-clouds bg-rellax"
      draggable="false"
      alt=""
      data-rellax-zindex="4"
      data-rellax-speed="2"
    />
  </div>
</template>

<script>
import Rellax from 'rellax'

export default {
  name: 'TrianglesSeparator',
  mounted () {
    // eslint-disable-next-line
    const rellax = new Rellax('.bg-rellax', {
      center: true
    })
  }
}
</script>

<style lang="scss" scoped>
.triangles-separator {
  position: relative;
  font-size: 0;
  width: 100%;
  height: 458px;
  background-color: $c-dark;
}

.bg {
  width: 100%;
  height: 150px;
  background-color: $c-brown;
  position: relative;
  z-index: 6;
  top: -1px;
}

.triangles {
  width: 1920px;
  height: auto;
  user-select: none;
  pointer-events: none;
  position: absolute;
  left: calc(50% - 960px);
  top: 140px;
}

.bg-back {
  top: 340px;
}

.bg-middle {
  top: 220px;
}

.bg-front {
  top: 148px;
}

.bg-clouds {
  top: 600px;
}
</style>
